import { themeLight } from './theme.light';
import { TOKEN_PREFIX } from './cssVars';
/**
 * Role-based tokens — the only value source for `src/ui` primitives. Each entry is a
 * `var(--tf-<role>)` reference, never a value; the values live in `theme.light.ts` /
 * `theme.dark.ts` and reach the DOM via `cssVars.ts`. That indirection is what keeps an
 * inline style theme-aware: the `var()` resolves from the cascade, so `.dark` on an
 * ancestor re-points it — no dark counterpart of this file is needed.
 *
 * DERIVED rather than hand-written: a literal map would lose per-role JSDoc anyway
 * (the `Record<SemanticToken, string>` return type drops hover docs), so per-role
 * documentation lives in `theme.light.ts` instead. What this file still buys over a
 * raw `var()` string: typo safety (a misspelled key is a compile error, not a silently
 * unstyled element) and one migration seam (no consumer hardcodes the `--tf-` prefix).
 *
 * AT MIGRATION: replace the derivation with an explicit map onto the target's tokens.
 */ export var semantic = Object.fromEntries(Object.keys(themeLight).map(function(role) {
    return [
        role,
        "var(".concat(TOKEN_PREFIX).concat(role, ")")
    ];
}));
